import { PurchaseStatus } from "@/api/article";
import { Badge } from "@/components/ui/badge";
import React from "react";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";

export const PurchaseStatusBadge = ({
  status,
  ...props
}: { status: PurchaseStatus } & React.HtmlHTMLAttributes<HTMLDivElement>) => {
  const vt = useVisibleT();
  switch (status) {
    case "DELIVERED":
      return (
        <Badge {...props} variant="success">
          {vt("bo.eshop.status.delivered", "Commande livrée")}
        </Badge>
      );
    case "IN_DELIVERY":
      return (
        <Badge {...props} variant="default">
          {vt("bo.eshop.status.inDelivery", "En cours de livraison")}
        </Badge>
      );
    case "SHIPPED":
      return (
        <Badge {...props} variant="default">
          {vt("bo.eshop.status.shipped", "Commande expédiée")}
        </Badge>
      );
    case "PAID_FOR":
      return (
        <Badge {...props} variant="destructive">
          {vt("bo.eshop.status.paidFor", "Commande réglée")}
        </Badge>
      );
    case "WAITING_PAYMENT":
      return (
        <Badge {...props} variant="warning">
          {vt("bo.eshop.status.waitingPayment", "En attente de paiement")}
        </Badge>
      );
  }
};
